import React from 'react';
import { Routes, Route } from "react-router-dom";
import Staff from './personal_information_management';
import DepartmentRoleManagement from './department_role_management';
import DepthDataManagement from './depth_data_management';
import PermissionList from '../permission_management/PermissionList'
import Home from './views/home'
import NoPermission from './views/nopermission'
import PermissionStatistic from './views/permission_statistic'
//加外匡
import Main from '../utility/Main';
import Label_language from "../language";
const label_language = Label_language.organization_structure

const MainRoute = () => {
    return (
        <Routes>
            <Route path="/">
                <Route path={''} element={<Main language={label_language} />} />
                <Route path="departmentRole" element={<DepartmentRoleManagement mode={'departmentRole'} key={'departmentRole'} />} />
                <Route path="department" element={<DepartmentRoleManagement mode={'department'} key={'department'} />} />
                <Route path="structure" element={<DepartmentRoleManagement propsFirstDepth='單位結構' propsNameDepartment={null} mode={'structure'} key={'structure'} />} />
                <Route path="role" element={<DepartmentRoleManagement mode={'role'} key={'role'} />} />
                <Route path="depth" element={<DepthDataManagement />} />
                <Route path="staff" element={<Staff
                // staff_id={26}
                // show_tab_bar={false}
                // show_chart={false}
                // show_header_title={false}
                // show_tool_bar={false} 
                staffApi = "/library/organization_structure/api/staff/concatenation" //staff 的api 名稱
                />} />
                <Route path="staff_role" element={<Staff
                    departmentMode='structure'
                // staff_id={26}
                // show_tab_bar={false}
                // show_chart={false}
                // show_header_title={false}
                // show_tool_bar={false} 
                />} />
                <Route path={'permission_management'} element={<PermissionList />} />
                <Route path="home" element={<Home />} />
                <Route path="noPermission" element={<NoPermission />} />
                <Route path="permission_statistic" element={<PermissionStatistic />} />
            </Route>
        </Routes>


    );
}
export default MainRoute;